// filepath: c:\Users\gelis\Documents\GitHub\PisikolojiWeb\frontend\src\features\content\contentService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + '/api/content/';

// Bir sayfanın içeriğini getir
const getContent = async (page) => {
  const response = await axios.get(API_URL + page);
  return response.data;
};

// Bir sayfanın içeriğini oluştur/güncelle
const updateContent = async (page, contentData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.put(API_URL + page, contentData, config);
  return response.data;
};

const contentService = {
  getContent,
  updateContent,
};

export default contentService;